var map = {
	"./": 82,
	"./ca": 1128,
	"./ca.js": 1128,
	"./cn": 1129,
	"./cn.js": 1129,
	"./en": 608,
	"./en.js": 608,
	"./es": 1130,
	"./es.js": 1130,
	"./fi": 1131,
	"./fi.js": 1131,
	"./formatted-message": 609,
	"./formatted-message.js": 609,
	"./index": 82,
	"./index.js": 82,
	"./ja": 1132,
	"./ja.js": 1132,
	"./locales": 159,
	"./locales.js": 159,
	"./pt": 1133,
	"./pt.js": 1133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1998;